import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";

const TableEditIconSVG = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const predefinedSizes = {
    small: { ...themeValue?.fontSmlSize?.size },
    medium: { ...themeValue?.fontMediumSize?.size },
    large: { ...themeValue?.fontLgSize?.size },
  };
  const { size, width, height } = props;
  const finalSize = predefinedSizes[size] || { width, height };

  return (
    <svg
      width={finalSize.width || "24"}
      height={finalSize.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5111 22.5099C14.0911 22.5099 13.7111 22.3599 13.4311 22.0799C13.0911 21.7499 12.9411 21.2599 13.0211 20.7499L13.2511 19.16C13.3011 18.78 13.5311 18.32 13.8111 18.04L17.9611 13.89C18.5011 13.35 19.0311 13.07 19.5911 13.0099C20.2811 12.9399 20.9711 13.24 21.6211 13.89C22.2711 14.54 22.5711 15.22 22.5011 15.92C22.4511 16.48 22.1611 17.01 21.6211 17.55L17.471 21.6999C17.201 21.9699 16.741 22.1999 16.351 22.2599L14.7711 22.4899C14.6811 22.4999 14.5911 22.5099 14.5111 22.5099ZM19.7711 14.5099C19.7611 14.5099 19.741 14.5099 19.731 14.5099C19.531 14.53 19.2911 14.6799 19.0111 14.9599L14.8611 19.1099C14.8111 19.1599 14.741 19.3099 14.731 19.3799C14.6146 20.1848 15.2896 20.8829 16.0979 20.7936L16.1311 20.79C16.2011 20.78 16.3511 20.7 16.4011 20.66L20.5511 16.5099C20.8311 16.2299 20.9811 15.99 21.0011 15.79C21.0211 15.56 20.8711 15.2899 20.5511 14.9699C20.2511 14.6599 19.9911 14.5099 19.7711 14.5099Z"
        fill="currentColor"
      />
      <path
        d="M20.491 18.37C20.421 18.37 20.361 18.36 20.291 18.34C18.791 17.92 17.591 16.72 17.171 15.22C17.061 14.82 17.291 14.41 17.691 14.3C18.101 14.19 18.501 14.4201 18.611 14.8201C18.891 15.8201 19.691 16.62 20.691 16.9C21.091 17.01 21.3211 17.4301 21.2111 17.8201C21.121 18.1601 20.811 18.37 20.491 18.37Z"
        fill="currentColor"
      />
      <path
        d="M7.5 1.75C7.5 1.33579 7.83579 1 8.25 1C8.66421 1 9 1.33579 9 1.75V22.25C9 22.6642 8.66421 23 8.25 23C7.83579 23 7.5 22.6642 7.5 22.25V1.75Z"
        fill="currentColor"
      />
      <path
        d="M22.25 8C22.6642 8 23 8.33579 23 8.75C23 9.16421 22.6642 9.5 22.25 9.5L1.75 9.5C1.33579 9.5 1 9.16421 1 8.75C1 8.33579 1.33579 8 1.75 8L22.25 8Z"
        fill="currentColor"
      />
      <path
        d="M13.25 15C13.6642 15 14 15.3358 14 15.75C14 16.1642 13.6642 16.5 13.25 16.5L1.75 16.5C1.33579 16.5 1 16.1642 1 15.75C1 15.3358 1.33579 15 1.75 15L13.25 15Z"
        fill="currentColor"
      />
    </svg>
  );
};
const TableEditIcon = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const { size, color } = props;
  const predefinedSizes = {
    small: themeValue?.fontSmlSize,
    medium: themeValue?.fontMediumSize,
    large: themeValue?.fontLgSize,
  };
  return (
    <Icon
      component={TableEditIconSVG}
      style={{
        // color: color || themeDefault?.info?.newConfig?.color,

        fontSize: predefinedSizes[size] || predefinedSizes.medium,
      }}
      {...props}
    />
  );
};

export default TableEditIcon;
